// Předpřipravené workshopy, které může master admin jedním klikem přidat do databáze
// (přidá se do té databáze, na kterou je právě napojený backend — tedy i do produkční
// po nasazení). Import jde přes POST /api/workshops/import (idempotentní upsert podle id).
import socialniSite1 from "./bundled/socialni-site-1-stupen.json";
import socialniSite2 from "./bundled/socialni-site-2-stupen.json";
import wellbeing1 from "./bundled/wellbeing-1-stupen.json";
import wellbeing2 from "./bundled/wellbeing-2-stupen.json";

export const BUNDLED_WORKSHOPS = [
  { key: "wellbeing-1stupen", label: "Wellbeing (1. stupeň)", payload: wellbeing1 },
  { key: "wellbeing-2stupen", label: "Wellbeing (2. stupeň)", payload: wellbeing2 },
  { key: "socialni-site-1stupen", label: "Sociální sítě (1. stupeň)", payload: socialniSite1 },
  { key: "socialni-site-2stupen", label: "Sociální sítě (2. stupeň)", payload: socialniSite2 },
];
